<template>
  <div class="header">
    <div v-if="userInfo&& $route.path!=='/password'" class="team-picker" ref="selectBox">
      <a-select
        v-model="selectTeam"
        style="width: 200px"
        :options="options"
        placeholder="队伍选择"
        :getPopupContainer="()=>this.$refs.selectBox"
        @change="handleTeamChange"
      ></a-select>
    </div>
    <div v-if="userInfo" class="data-outport" >
<!--      <a-button-->
<!--          type="text"-->
<!--          style="border: 1px solid white;background-color: #000000;color: #FFFFFF"-->
<!--          @click="downloadAttachRow()"-->
<!--      >导出</a-button>-->
      <a-button v-if="$route.path==='/table'"
          type="link"
          style="border: 1px solid white;background-color: #000000;color: #FFFFFF"
          :href="downloadUrl()"
          target="_blank"
      >导出</a-button>
      <a-button v-if="$route.path==='/table' || $route.path==='/update' || $route.path==='/add_sub_event' || $route.path==='/rankings'|| $route.path==='/data_maintenance'||$route.path==='/training' "
                @click="()=>{if(userInfo) { this.$router.push('/list')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        列表 </a-button>
      <a-button v-if="$route.path==='/update' "
                @click="()=>{if(userInfo) { this.$router.push('/table')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        表格 </a-button>
      <a-button v-if="$route.path==='/table' && permission"
          @click="()=>{if(permission) { this.$router.push('/update')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        更新比分 </a-button>
      <a-button v-if="$route.path==='/list' "
                @click="()=>{if(userInfo) { this.$router.push('/static')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        分析 </a-button>
      <a-button v-if="($route.path==='/list' && !['foreign_men','foreign_women'].includes(this.$store.state.currentTeam)) "
                @click="()=>{if(userInfo) { this.$router.push('/map')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        航线 </a-button>
      <a-button v-if="$route.path==='/static'  ||$route.path==='/update' ||$route.path==='/map' "
                @click="()=>{if(userInfo) { this.$router.push('/list')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        列表 </a-button>
      <a-button v-if="$route.path==='/map' || ($route.path==='/list' && !['foreign_men','foreign_women'].includes(this.$store.state.currentTeam)) "
                @click="()=>{if(userInfo) { this.$router.push('/training')} }"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">
        训练 </a-button>
<!--      <a-button v-if="$route.path==='/list' && permission "-->
<!--                @click="()=>{if(userInfo) { this.$router.push('/rankings')} }"-->
<!--                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">-->
<!--        积分 </a-button>-->
      <a-checkbox v-if="$route.path==='/table' && permission"
                  :checked="$store.state.editMode" @change="this.check_change" style="color: #FFFFFF;margin-left: 15px"
      >编辑已结束比赛</a-checkbox>

<!--      <a-button @click="()=>{if(userInfo) { this.$router.push('/Analysis')} }"-->
<!--                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 20px">-->
<!--        Analysis </a-button>-->
    </div>
    <div class="title">
      <img class="logo" src="~@/assets/logo.png"/>
      中国乒乓球队运动员年度国际赛事管理系统
      <span v-if="LOCAL()">
        LOCAL
      </span>
    </div>

    <div v-if="userInfo" class="maintain-btn">
      <a-button v-if="$route.path==='/list' && permission"
          type="primary" size="small" @click="$router.push('/data_maintenance')"
                style="border: 1px solid white;background-color: #000000;color: #FFFFFF;margin-left: 15px">维护</a-button>
    </div>

    <div v-if="!userInfo" class="user-name" @click="toLogin">
      用户登录
    </div>
    <div v-else class="user-name">
      <a-popover placement="bottomLeft">
        <template slot="content">
          <p class="dropdown-menu-item"
              @click="toChangePassword">修改密码</p>
          <p class="dropdown-menu-item"
              @click="logout">退出登录</p>
        </template>
        <div>
          <a-icon class="user-icon" type="user"/>
          {{userInfo.name}}
        </div>
      </a-popover>

    </div>
  </div>
</template>

<script>
import {downloadAttachment, userLogout, url, checkMaintainData, LOCAL} from '@/api'
import {getToken} from "@/api/http";


export default {
  name: 'Header',
  components: {
  },

  data(){
    return {
      selectTeam: undefined,
      permission:false
    }
  },
  updated(){
    this.checkPermissionMaintainData()
  },
  computed:{
    userInfo(){
      return this.$store.state.userInfo
    },
    options() {
      return this.$store.state.currentTeamList.filter(r=>{
        if(this.$route.path!=='/static' && this.$route.path!=='/list'){
          return r.value!=='foreign_men' && r.value!=='foreign_women'
        }
        return true
      })
    },
    currentTeam() {
      return this.$store.state.currentTeam
    }
  },
  watch: {
    options: {
      handler(_, newValue){
        if(newValue) {
        this.selectTeam = this.currentTeam
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    LOCAL() {
      return LOCAL
    },
    toLogin() {
      if (this.$route.path !== '/login') {
        this.$router.push('/login')
      }
    },
    check_change(){
      this.$store.commit('setEditMode')
    },
    toChangePassword() {
      if (this.$route.path !== '/password') {
        this.$router.push('/password')
      }
    },
    async checkPermissionMaintainData() {
      if(this.userInfo && this.$store.state.token){
        const response = await checkMaintainData()
        // console.log(response.data)
        if (response.status === 200) {
          if(response.data.allow_maintain && response.data.allow_maintain==='yes'){
            this.permission=true
          }
        }
      }

    },
    async logout() {
      const response = await userLogout()
      if (response.status === 200) {
        this.$store.commit('clearUserInfo')
        this.$store.commit('clearToken')
        this.$store.commit('clearCurrentTeamListo')
        this.$store.commit('clearCurrentTeam')
        this.$store.commit('setCurrentTeam', 'women')
        this.$router.push('/login')
      }
    },
    handleTeamChange() {
      this.selectTeamSync()
    },
    async selectTeamSync() {
      await this.$store.commit('setCurrentTeam', this.selectTeam)
    },
    /** 下载附件 */
    downloadAttachRow() {
      downloadAttachment(this.selectTeam)
    },
    downloadUrl(){
        return url('/file/participation/table',{token:getToken(),team:this.selectTeam})
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  background: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 66px;

  .user-name {
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
  .maintain-btn {
    position: absolute;
    right: 130px;
  }

  .team-picker {
    position: absolute;
    left: 50px;
  }
  .data-outport {
    position: absolute;
    left: 280px;
  }
  .title {
    display: flex;
    align-items: center;
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    /* or 120% */

    text-align: center;
    letter-spacing: -0.015em;
    .logo {
      width: 35px;
      margin-right: 20px;
    }
  }
  .user-icon {
    border-radius: 50%;
    border: 1px solid #fff;
  }
}
.dropdown-menu-item {
  cursor: pointer;
}

/deep/.ant-select,
/deep/.ant-select-arrow,
/deep/.ant-select-arrow-icon {
  color: #fff;
}
/deep/.ant-select-selection {
  background: #000000;
}
/deep/.ant-select-selection--single {
  background: #000000;
}

/deep/.ant-select-dropdown,
/deep/.ant-select-dropdown--single,
/deep/.ant-select-dropdown-menu,
/deep/.ant-select-dropdown-menu-item {
  color: #fff;
  background: #000000;
}

/deep/.ant-select-dropdown-menu-item:hover,
/deep/.ant-select-dropdown-menu-item-active,
/deep/.ant-select-dropdown-menu-item-selected {
  color: #000;
  background: #777777;
}
</style>
